<div class="d-flex align-items-center"
    [style.padding-top.px]="item?.padding"
    [style.padding-bottom.px]="item?.padding"    
>
    <div class="col-auto">
        <h5 class="mb-0">{{ item?.content }}</h5>
    </div>
    <div class="col">
        <hr />
    </div>
</div>